import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { ensureMsalInitialized } from './app/auth/msal.setup';
import { environment } from './environments/environment';

console.log(`Build number: ${environment.buildNumber}`);
console.log(`loading environment.json from assets/environment.json`);

void ensureMsalInitialized()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => console.error(err));
